export default __webpack_public_path__ + "static/media/audit_icon.082a3801.svg";